import React from 'react';
import { Box } from '@mui/material';

export const TAGLINE = 'One profile. Every application.';

interface MarkProps {
  size?: number;
}

/** The JobFlo mark: three lines growing longer on a blue square, with the amber dot. Decorative; the wordmark names it. */
export const Mark: React.FC<MarkProps> = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 160 160" fill="none" aria-hidden="true" focusable="false">
    <rect width="160" height="160" rx="38" fill="#1F5BFF" />
    <path d="M38 56 H74 M38 82 H98 M38 108 H112" stroke="#FFFFFF" strokeWidth="14" strokeLinecap="round" />
    <circle cx="124" cy="56" r="10" fill="#FFB020" />
  </svg>
);

interface LogoProps {
  /** Height of the mark in px; the wordmark scales with it. */
  size?: number;
  /** For a dark background. */
  light?: boolean;
}

/** The horizontal lockup: the mark and the lower-case wordmark in Sora Semibold. */
const Logo: React.FC<LogoProps> = ({ size = 32, light = false }) => (
  <Box component="span" role="img" aria-label="JobFlo" sx={{ display: 'inline-flex', alignItems: 'center', gap: `${Math.round(size * 0.24)}px`, verticalAlign: 'middle' }}>
    <Mark size={size} />
    <Box
      component="span"
      aria-hidden="true"
      sx={{ fontFamily: '"Sora", "Helvetica Neue", sans-serif', fontWeight: 600, fontSize: `${Math.round(size * 0.78)}px`, letterSpacing: '-0.03em', lineHeight: 1, color: light ? '#FFFFFF' : '#0F1B2D' }}
    >
      jobflo
    </Box>
  </Box>
);

export default Logo;
